import EstimateDocument from './EstimateDocument';

export default function DownloadEstimate() {
  return (
    <div className="d-none">
      <EstimateDocument download />
    </div>
  );
}
